/**
 * Created by lkornilenko on 6/17/15.
 */

var flowRunnerIsLaunching = false;

function FlowRunner(flow, data){
  this.flow = flow;

  this.flowcontainer = null;
  this.stepcontainer = null;

  this.data = data;
  this.currentStep = null;

  this.cachedtemplates = {};
  this.lastRenderTime = null;

  var thisfr = this;

  // init flow
  this.initflow = function(){
    var self = this;

    flowRunnerIsLaunching = true;
    self.doCacheTemplates(function (){
      flowRunnerIsLaunching = false;

      // make flow container, then insert step container
      self.flowcontainer = $("<div>").attr("data-flow-name", self.flow.name).css('height', '0px');
      $("#content").prepend(self.flowcontainer);
      self.stepcontainer = $("<div>").attr("class", "stepcontainer");
      self.flowcontainer.append(self.stepcontainer);

      // open
      var start = self.flow.open(self.data, self.stepcontainer, self);
      if (start){
        self.goTo(start);
      } else {
        self.close();
      }
    });
  };

  // set up link handlers for the step, usually right after it is rendered
  this.bindHandlers = function (){
    var self = this;
    var currentStep = self.flow.steps[self.currentStep];
    $(self.stepcontainer).find("[data-flow-transition]").on('click', function(){
      if (self.renderedRecently()) return;
      var flowTransitionAction = $(this).data("flowTransition");
      if (currentStep[flowTransitionAction])
        currentStep[flowTransitionAction](self.data, self.stepcontainer, self, $(this));
    });
    $(self.stepcontainer).find("input[data-flow-handler], select[data-flow-handler]").on('change', function(){
      if (self.renderedRecently()) return;
      var flowHandlerAction = $(this).data("flowHandler");
      if (currentStep[flowHandlerAction])
        currentStep[flowHandlerAction](self.data, self.stepcontainer, self, this);
    });
    $(self.stepcontainer).find("[data-flow-step]").on('click', function(){
      if (self.renderedRecently()) return;
      var step = $(this).data("flowStep");
      setTimeout(function() {
        self.goTo(step);
      }, 500);
    });
    $(self.stepcontainer).find("[data-flow-close]").on('click', function(){
      if (self.renderedRecently()) return;
      self.close(true);
    });
    $(self.stepcontainer).find('[data-flow-type="combobox"]').combobox({appendTo: '.modal-box'});
  };

  // populate cache of templates
  this.doCacheTemplates = function(onSuccess){
    var t = {}, self = this;

    for (var i in self.flow.steps){
      if (Array.isArray(self.flow.steps[i].template)){
        t[i] = "flow/" + self.flow.steps[i].template[0] + "-" + self.flow.steps[i].template[1];
      } else {
        t[i] = "flow/" + self.flow.name.toLowerCase() + "-" + self.flow.steps[i].template;
      }
    }

    $.ajax({
      type: "POST",
      url: "/template",
      data: JSON.stringify(t),
      success: function (data) {
        for (var i in data){
          self.cachedtemplates[i] = data[i];
        }
        !onSuccess || onSuccess();
      },
      dataType: "json",
      contentType: "application/json"
    }).fail(self.defaultAJAXErrorHandler);
  };

  // go to the specified step
  this.goTo = function (stepName, msec){
    var self = this;
    var previousStep = self.currentStep;
    var wait = (parseInt(msec) ? parseInt(msec) : 0); // goTo transition delay (milliseconds)

    // bad template name or called too late due to ajax success handler, etc.
    if (!self.existsInDOM() || !self.cachedtemplates[stepName])
      return;

    // close out the old step
    if (self.currentStep && self.flow.steps[self.currentStep].close)
      self.flow.steps[self.currentStep].close(self.data, self.stepcontainer, self);

    self.currentStep = stepName;

    // open up the new step
    if (self.flow.steps[self.currentStep].open)
      self.flow.steps[self.currentStep].open(self.data, self.stepcontainer, self, previousStep);
    // if a different step was opened, stop here
    if (self.currentStep != stepName)
      return;

    // check renderReady (if it exists, it returns a bool indicating if the step is ready to be rendered) and render
    if (!self.flow.steps[self.currentStep].renderReady || self.flow.steps[self.currentStep].renderReady(self.data, self.stepcontainer, self, previousStep)){
      setTimeout(function() {
        self.render();
      }, wait);
    }
  };

  // compile and render the handlebars template
  this.render = function (assertStep){
    var self = this;

    // if this is called async'ly then a stale refresh request might be issued
    if (!self.existsInDOM() || (assertStep && assertStep != self.currentStep)){
      return;
    }

    if (self.flow.steps[self.currentStep].render){
      self.flow.steps[self.currentStep].render(self.data, self.stepcontainer, self);
    }

    self.stepcontainer.html(Handlebars.compile(self.cachedtemplates[self.currentStep])(self.data));

    // scroll to show title
    if( $('.flowmodal', self.stepcontainer).offset().top < $(window).scrollTop() ){
      $('html, body').animate({scrollTop: $('.flowmodal', self.stepcontainer).offset().top});
    }
    self.bindHandlers();
    self.lastRenderTime = (new Date()).getTime();

    if (self.flow.steps[self.currentStep].postRender){
      self.flow.steps[self.currentStep].postRender(self.data, self.stepcontainer, self);
    }
  };

  // close modal dialog
  this.close = function(didCancel){
    var self = this;

    // close out the old step
    if (self.currentStep && self.flow.steps[self.currentStep].close)
      self.flow.steps[self.currentStep].close(self.data, self.stepcontainer, self);

    // close and remove from DOM
    self.flow.close(self.data, self.stepcontainer, self, didCancel);
    self.flowcontainer.html("").remove();
  };

  // handle AJAX errors
  this.defaultAJAXErrorHandler = function(){
    thisfr.close();
    flowRunnerIsLaunching = false;
    show_alert(_error_label, rmclang.flow_ajax_error);
  };

  this.defaultErrorHandler = function(errorMessage){
	thisfr.close();
	flowRunnerIsLaunching = false;
	show_alert(_error_label, errorMessage);
  };

  // call a method in the current step
  this.callMethod = function(methodName){
    var self = this;
    if (self.flow.steps[self.currentStep][methodName])
      self.flow.steps[self.currentStep][methodName](self.data, self.stepcontainer, self);
  };

  // some widgets may do delayed initialization after they are rendered
  this.renderedRecently = function(){
    return (new Date()).getTime() - this.lastRenderTime < 500;
  };

  this.existsInDOM = function(){
    return $.contains(document.documentElement, this.flowcontainer[0]);
  };

  this.initflow();
}
